import React from 'react';
import logo from '../../Images/logo.jpg'
import './Footer.css'
const Footer = () => {
    return (
      

            <div >

<nav className="navbar navbar-expand-lg navbar-light bg-light">

  <div className="container-fluid">

    




    <div className="d-flex align-items-center">
  
    


  
   
    </div>
 
  </div>

</nav>


<div className="container">

</div>


<footer className="text-center text-lg-start bg-light text-muted">


 


  <section className="">
    <div className="container text-center text-md-start mt-5">

      <div className="row mt-3">
      
        <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
      
          <h6 className="text-uppercase fw-bold mb-4">
            <i className="fas fa-gem me-3"></i>Trendy Fashion Craze  (TFC)
          </h6>
          <img src={logo} alt="" />
          <p>
            Here you can use rows and columns to organize your footer content. Lorem ipsum
            dolor sit amet, consectetur adipisicing elit.
          </p>
        </div>
      
        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
  
          <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
          <p><i className="fas fa-home me-3"></i> Dhanmondi , 1209, BD</p>
          <p>
            <i className="fas fa-envelope me-3"></i>
            info@trendy.com
          </p>
          <p><i className="fas fa-phone me-3"></i> + 088 525458547</p>
          <p><i className="fas fa-print me-3"></i> + 0331 234 567 89</p>
        </div>
  
      </div>

    </div>
  </section>

  <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">

    <div className="me-5 d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>



    <div>
      <a href="h" className="me-4 text-reset">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="d" className="me-4 text-reset">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="d" className="me-4 text-reset">
        <i className="fab fa-google"></i>
      </a>
      <a href="d" className="me-4 text-reset">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="d" className="me-4 text-reset">
        <i className="fab fa-linkedin"></i>
      </a>
      <a href="d" className="me-4 text-reset">
        <i className="fab fa-github"></i>
      </a>
    </div>
  
  </section>

  <div className="text-center p-4" >
    © 2021 Copyright:TRENDY_FASHION_CRAZE
@All Rights Reserved
  </div>

</footer>

</div>



     
    );
};

export default Footer;